/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { GetService, PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import BounceLoader from "react-spinners/BounceLoader";
import { OrderPlacedAlert } from "../../../Helper/Toastr";

export default function GiftCards() {
  let [loading, setLoading] = useState(true);
  const [CardList, setCardList] = useState([]);
  
  const Token = localStorage.getItem("token");
  const navigate = useNavigate()

  useEffect(() => {
    GetList();
  }, []);

  function GetList() {
    setLoading(true);
    GetService(API_URL.GET_GIFTCARDS_LIST).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setCardList(res?.data?.data);
      }
      setLoading(false);
    });
  }

  function AddtoCard(id) {
    console.log(id)
    console.log(Token)
    if (Token) {
      setLoading(true)
      PostService(API_URL.ADD_GIFT_CARD, {gift_id:id,quantity:1}).then((res) => {
        console.log(res);
        if (res?.data?.status) {
          setLoading(false); 
          navigate("/add-to-cart");
        }
        setLoading(false);
      });
    }else{
      return;
    }




  }
  return (
    <div className="Gallery-Wraps contact program gift-cards">
      <main>
        <div
          className="tp-project__area "
          // data-background="assets/img/breadcrumb/routing.png"
          style={{
            backgroundSize: "cover",
            backgroundImage: `url(${"assets/img/breadcrumb/routing.png"})`,
          }}
        >
          <div className="container">
            <div style={{minHeight:'400px'}} className="row text">
              {!loading && (
                <>
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center mb-50 mt-25">
                    <h4 className="text-left second">Gift Cards</h4>
                    <p className="w-75 m-auto">
                    Versatile, Convenient, and Always Appreciated. Whether it's for birthdays, holidays, or any special occasion, our gift cards offer the perfect solution.
                    </p>
                  </div>
                  {CardList &&
                    CardList.map((list, i) => {
                      return (
                        <div
                          className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-45 wow tpfadeUp"
                          data-wow-duration=".9s"
                          data-wow-delay=".3s"
                          style={{
                            visibility: "visible",
                            animationDuration: "0.9s",
                            animationDelay: "0.3s",
                            animationName: "tpfadeUp",
                          }}
                          key={i}
                        >
                          <div className="tp-project__item gift_card">
                            <div className="tp-project__thumb p-relative bg-light d-flex justify-content-center align-items-center">
                              <img src={list?.image} alt="" />
                              {/* <div className="tp-project__shape">
                        <img src="assets/img/team/shape-1-1.png" alt="" />
                      </div> */}
                            </div>
                            <div className="tp-project__content">
                              <h5 className="tp-project__title">
                               <Link >{list?.name}</Link>  
                              </h5>
                              <span style={{textTransform:'none'}}>{list?.description}</span>
                              {/* <div className="tp-footer-2__social-box pt-10 pb-10">
                                <Link to={""}>
                                  {" "}
                                  <i className="fa-brands fa-apple" />
                                </Link>
                                <Link to={""}>
                                  {" "}
                                  <i className="fa-brands fa-facebook-f" />
                                </Link>
                                <Link to={""}>
                                  {" "}
                                  <i className="fa-brands fa-skype" />
                                </Link>
                                <Link to={""}>
                                  {" "}
                                  <i className="fa-brands fa-twitter" />
                                </Link>
                              </div> */}
                              <div className="dispay-content d-flex mt-3">
                              {Token && <h6 className="pointer" onClick={()=>AddtoCard(list?.id)}>Add to Cart</h6>}
                               {!Token && <h6 className="pointer" data-bs-toggle="modal"
                                  data-bs-target="#exampleModal" >Add to Cart</h6>}
                                <h3>${list?.price}</h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </>
              )}
            </div>
          </div>
        </div>

        <UpperFooterSlider />
      </main>

      {loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#607fe6"}
            loading={loading}
            speedMultiplier={2}
            size={50}
          />
          <div className="fw-semibold">Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
